import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {useEffect, useState} from "react";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {css} from "@emotion/css";
import {
    RaikoCustomSimpleChip
} from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleChip/RaikoCustomSimpleChip";
import {RaikoChipTypes} from "../../raikoComponents/raikoCustomChip/RaikoChipTypes";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import {AppVersionDetail} from "../../component/appVersionDetail/AppVersionDetail";
import {RaikoIcon} from "../../raikoComponents/raikoIcon/RaikoIcon";
import {RaikoIconTypes} from "../../raikoComponents/raikoIcon/RaikoIconTypes";
import {RaikoCustomTooltip} from "../../raikoComponents/raikoTooltip/RaikoCustomTooltip";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {readToken} from "../../service/authService/AuthService";
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";

export const AppVersionManager = () => {

    let page = 0;
    let appVersionSelectedItemId = -1;

    const snackbarDispatcher = useSnackbarDispatcher()
    const snackbar = new SnackbarHelper(snackbarDispatcher)

    const token = readToken()


    const [tableLoadingState, setTableLoadingState] = useState(false);
    const [appVersionsList, setAppVersionsList] = useState([]);
    const [pageCount, setPageCount] = useState(5);

    useEffect(() => {
        // TODO : this method is for add fake data and must remove after connected to server

        if (appVersionsList && appVersionsList.length === 0) {
            setAppVersionsList([generateAppVersionRow(
                1,
                1,
                "نسخه اول",
                12,
                11,
                true,
                true,
                "appLink"
            )
            ])
        }
    }, []);

    function generateAppVersionRow(id, number, title, versionNumber, minimumVersion, enabled, mandatory, appLink) {
        return ({
            id,
            number,
            title,
            versionNumber,
            minimumVersion,
            enabled: enabled ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"غیرفعال"} type={RaikoChipTypes.error}/>,
            mandatory: mandatory ?
                <RaikoCustomSimpleChip title={"اجباری"} type={RaikoChipTypes.error}/> :
                <RaikoCustomSimpleChip title={"اختیاری"} type={RaikoChipTypes.success}/>,
            access: <div
                className={css`
                  display: flex;
                  justify-content: center;
                  gap: .5rem;`}>

                <RaikoCustomTooltip title={"حذف"}>
                    <div>
                        <RaikoIcon icon={RaikoIconTypes.icDeleteBorder}
                                   className={css`
                                     &:hover {
                                       cursor: pointer;
                                       background-color: var(--color-primary)
                                     }`}
                                   onClick={_ => {
                                       setDeleteDialogOpenState(true)
                                   }}
                        />
                    </div>
                </RaikoCustomTooltip>

                <RaikoCustomTooltip title={"کپی لینک"}>
                    <div>
                        <RaikoIcon icon={RaikoIconTypes.icLink}
                                   className={css`
                                     &:hover {
                                       cursor: pointer;
                                       background-color: var(--color-primary)
                                     }`}
                                   onClick={_ => {
                                       navigator.clipboard.writeText(appLink)
                                           .then(_ => {
                                               snackbar.showSuccessMessage("لینک با موفقیت کپی شد.")
                                           }).catch(_ => {
                                           snackbar.showErrorMessage("خطا در کپی لینک !")
                                       })
                                   }}
                        />
                    </div>
                </RaikoCustomTooltip>

            </div>
        })
    }

    function getDataFromServer() {

    }

    function handleChangePage(page) {
        this.page = page
        getDataFromServer()
    }

    function handleAppVersionSelected(id) {
        appVersionSelectedItemId = id;
        setAppVersionInfoDialogOpenState(true)
    }

    function handleOpenAddNewAppVersionDialog() {
        setAppVersionInfoDialogOpenState(true)
    }

    const [appVersionInfoDialogOpenState, setAppVersionInfoDialogOpenState] = useState(false);

    function handleCloseDialog() {
        appVersionSelectedItemId = -1
        setAppVersionInfoDialogOpenState(false)
    }

    const [deleteDialogOpenState, setDeleteDialogOpenState] = useState(false);

    function doDeleteItem() {

    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.AppVersionList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={appVersionInfoDialogOpenState}
                pageTitle={"جزئیات نسخه"}
                dialogSize={DialogSize.MEDIUM}
            >
                <AppVersionDetail appVersionId={appVersionSelectedItemId}/>
            </RaikoDefaultDialogPage>

            <RaikoConfirmDialog
                openConfirmDialog={deleteDialogOpenState}
                doAction={doDeleteItem}
                cancelAction={_ => {
                    setDeleteDialogOpenState(false)
                }}
            />
            <RaikoBaseContainer>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("نسخه ها", ""),
                        raikoBreadCrumbItemGenerator("لیست نسخه ها", ""),
                    ]}
                />

                <RaikoBaseCardContainer
                    className={css`
                      margin-top: 24px;
                      gap: 1rem`
                    }>
                    <div className={css`
                      display: flex;
                      justify-content: end;`
                    }>
                        <ButtonPrimaryRaiko label={"افزودن نسخه جدید"} onClick={handleOpenAddNewAppVersionDialog}/>
                    </div>
                    <RaikoCustomTable
                        isLoading={tableLoadingState}
                        data={appVersionsList}
                        header={appVersionTableHeader}
                        handlePaginationChange={handleChangePage}
                        rowClicked={handleAppVersionSelected}
                        pageCount={pageCount}
                    />
                </RaikoBaseCardContainer>

            </RaikoBaseContainer>
        </>
    )
}


const appVersionTableHeader = [
    {id: 'number', label: '#'},
    {id: 'title', label: 'عنوان'},
    {id: 'versionNumber', label: 'ورژن'},
    {id: 'minimumVersion', label: 'حداقل ورژن مجاز'},
    {id: 'enabled', label: 'وضعیت'},
    {id: 'mandatory', label: 'اجباری'},
    {id: 'access', label: 'دسترسی ها'},
]